<template>
    <div>
        <div class="title">{{ title || '投保企业信息' }}</div>
        <Form :model="form" :label-width="110" class="mt15" :rules="formRules" ref="form">
            <FormItem label="企业名称" class="w600" prop="subjectName">
                <Input v-model="form.subjectName" placeholder="请输入企业名称" @on-blur="change" :maxlength="50">
                </Input>
            </FormItem>
            <FormItem label="企业证件类型" class="w600" required>
                <Select v-model="form.idType" disabled>
                    <Option value="UNIFIED_SOCIAL_CREDIT_CODE">统一社会信用代码</Option>
                </Select>
            </FormItem>
            <FormItem label="企业证件编码" class="w600" prop="idNumber">
                <Input @on-blur="change" v-model="form.idNumber" placeholder="请输入企业证件编码" :maxlength="50"></Input>
            </FormItem>
            <FormItem label="企业地址：" class="w600" prop="areaCode">
                <Area v-model="form.areaCode" placeholder="请选择省市区" @get-city-str="areaChange" style="width:100%" />
            </FormItem>
            <FormItem label="详细地址：" class="w600" prop="address">
                <Input v-model="form.address" placeholder="请输入详细地址" :maxlength="50"></Input>
            </FormItem>
            <FormItem label="联系人姓名：" class="w600" prop="contactName">
                <Input v-model="form.contactName" placeholder="请输入联系人姓名" @on-blur="change" :maxlength="50"></Input>
            </FormItem>
            <FormItem label="联系人电话：" class="w600" prop="contactPhone">
                <Input v-model="form.contactPhone" placeholder="请输入联系人电话" :maxlength="11"></Input>
            </FormItem>
            <FormItem label="联系人邮箱：" class="w600" prop="contactEmail">
                <Input v-model="form.contactEmail" placeholder="请输入联系人邮箱" :maxlength="50"></Input>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import Area from '@/pages/haierProduct/components/common/Area'
export default {
    components: {Area},
    props: {
        info: {
            type: Object,
            default:{}
        },
        title: String
    },
    data() {
        return {
            loading: false,
            form:this.info||{},
            formRules: {
                subjectName: [{ required: true, message: '企业名称必填', trigger: 'blur'}],
                idNumber: [{ required: true, message: '企业证件编码必填', trigger: 'blur' }],
                areaCode: [{ required: true, message: '企业地址必填', trigger: 'change' }],
                address: [{ required: true, message: '详细地址必填', trigger: 'blur' }],
                contactEmail: [
                    { required: true, message: '联系人邮箱必填', trigger: 'blur' },
                    {required:true,message:'邮箱格式错误',trigger:'blur',type:'email'}
                ],
                contactName: [{ required: true, message: '联系人姓名必填', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '联系人电话必填', trigger: 'blur'},{message:'联系人电话格式错误',trigger:'blur',pattern:this.rules.phone}]
            }
        }
    },
    methods: {
        // 校验
        val() {
            return new Promise((resolve, rejct) => {
                this.$refs.form.validate(valid => {
                    resolve(valid ? this.form : false)
                })
            })
        },
        // 回传给父组件，父组件传入开票组件，开票组件的公司名称和社会代码用此组件的值
        change() {
            this.$emit('on-change', this.form);
            console.log(this.form,'0000000000000')
        },
        areaChange(val) {
            // this.form.areaCode = val[2].value
            // this.form.provinceCode = val[0].value
            // this.form.provinceName = val[0].label
            // this.form.cityCode = val[1].value
            // this.form.cityName = val[1].label
            // this.form.areaName = val[2].label
        }
    },

}
</script>
<style scoped lang="less">
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/common/ApplicantCompany.vue